import { api } from ".";

const basePath = "/shift";

export const getWorkShifts = async (params: Record<string, any> = {}) => {
  try {
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined)
    );
    const res = await api.get(`${basePath}/getMonthlyShifts`, {
      params: filteredParams,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const getAssignShifts = async (params: Record<string, any> = {}) => {
  try {
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined)
    );
    const res = await api.get(`${basePath}/getMonthlyAssignShifts`, {
      params: filteredParams,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const assignEmployee = async ({ shiftId, employees }: any) => {
  try {
    const res = await api.post(`${basePath}/assignEmployee`, {
      shiftId,
      employees,
    });
    return res?.data;
  } catch (error: any) {
    return error?.response?.data;
  }
};

export const createWorkShift = async ({
  departmentId,
  roleId,
  date,
  shift,
  notes,
}: any) => {
  try {
    const res = await api.post(`${basePath}/createShift`, {
      departmentId,
      roleId,
      date,
      shift,
      notes,
    });
    return res?.data;
  } catch (error: any) {
    return error?.response?.data;
  }
};

export const deleteShiftById = async ({ id }: any) => {
  try {
    const res = await api.delete(`${basePath}/deleteShift `, {
      data: {
        shiftId: id,
      },
    });
    return res?.data;
  } catch (error: any) {
    return error?.response?.data;
  }
};

export const deleteEmployeeFromShiftById = async ({
  shiftId,
  employeeId,
}: any) => {
  try {
    const res = await api.delete(`${basePath}/deleteEmployeeFromShift`, {
      data: {
        shiftId,
        employeeId,
      },
    });
    return res?.data;
  } catch (error: any) {
    return error?.response?.data;
  }
};

export const updateShiftById = async ({ id, updates }: any) => {
  try {
    const res = await api.patch(`${basePath}/updateShift`, {
      shiftId: id,
      ...updates,
    });
    return res?.data;
  } catch (error: any) {
    return error?.response?.data;
  }
};
